import React, { Component } from "react";
import PropTypes from "prop-types";
import Paper from "material-ui/Paper";
import { Box } from "rebass";
import Toggle from "material-ui/Toggle";

import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { DivTitle } from "../../styled";
import { BlockCounter, Counter, Alignment } from "../";
import { SketchColorPicker, UploadImage } from "../../../../../components";

class ItemBackgroundCarousel extends Component {
  constructor(props) {
    super(props);
    const {
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps,
      padding,
      width,
      alignment,
      backgroundColorParent
    } = props;

    this.state = {
      backgroundColorParent: backgroundColorParent,
      backgroundColor: backgroundColor,
      backgroundImage: backgroundImage,
      isBackgroundImage: isBackgroundImage,
      bgProps: bgProps,
      padding: padding,
      type: width.type || "%",
      contentWidth: width.contentWidth || 100,
      maxValueWidth: width.type === "px" ? 0 : 100,
      interval: width.type === "px" ? 20 : 1,
      valign: alignment.vertical,
      align: alignment.horizontal
    };
  }
  onUpdateUrl = value => {
    this.setState({ backgroundImage: value });

    this.updateContent("backgroundImage", value);
  };
  onToggle = (e, v) => {
    this.setState({ isBackgroundImage: v });
    this.updateContent("isBackgroundImage", v);
  };

  onChangeBackgroundImageProperties = (event, index, value, key) => {
    let { bgProps } = this.state;
    bgProps[key] = value;
    this.setState({
      bgProps: bgProps
    });
    this.updateContent("bgProps", bgProps);
  };
  onUpdateColor = color => {
    this.setState({ backgroundColor: color });
    this.updateContent("backgroundColor", color);
  };

  onUpdateColorParent = color => {
    this.setState({ backgroundColorParent: color });
    this.updateContent("backgroundColorParent", color);
  };
  onUpdatePadding = padding => {
    this.setState({ padding: padding });
    this.updateContent("padding", padding);
  };
  onSetValue = (key, value) => {
    this.setState({ contentWidth: value });
    this.updateContent("contentWidth", value);
  };
  onChangeType = (event, value) => {
    let width = 0;
    let content = this.state.contentWidth;
    let interval = 20;
    if (value === "%") {
      width = 100;
      content = 100;
      interval = 1;
    }
    this.setState({
      type: value,
      maxValueWidth: width,
      contentWidth: content,
      interval: interval
    });
    this.updateContent("type", value);
  };
  onChangeContentHorizontalAlign = value => {
    this.setState({
      align: value
    });
    this.updateContent("horizontal", value);
  };
  onChangeContentVerticalAlign = value => {
    this.setState({
      valign: value
    });
    this.updateContent("vertical", value);
  };
  updateContent = (key, value) => {
    const {
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps,
      padding,
      type,
      contentWidth,
      valign,
      align,
      backgroundColorParent
    } = this.state;
    const values = {
      backgroundColorParent:
        key === "backgroundColorParent" ? value : backgroundColorParent,
      backgroundColor: key === "backgroundColor" ? value : backgroundColor,
      backgroundImage: key === "backgroundImage" ? value : backgroundImage,
      isBackgroundImage:
        key === "isBackgroundImage" ? value : isBackgroundImage,
      bgProps: key === "bgProps" ? value : bgProps,
      padding: key === "padding" ? value : padding,
      width: {
        type: key === "type" ? value : type,
        contentWidth: key === "contentWidth" ? value : contentWidth
      },
      alignment: {
        vertical: key === "vertical" ? value : valign,
        horizontal: key === "horizontal" ? value : align
      }
    };
    this.props.updateBackground(values);
  };

  onUpdateDataBackgroundCarousel(value) {
    this.setState({
      backgroundCarousel: value
    });
    this.updateContent("backgroundCarousel", value);
  }

  renderBackgroundImage() {
    return (
      <div>
        <Box w={[1]} py={[1]}>
          <SelectField
            floatingLabelText="Size"
            onChange={(event, index, value) =>
              this.onChangeBackgroundImageProperties(
                event,
                index,
                value,
                "size"
              )
            }
            value={this.state.bgProps.size}
            autoWidth={true}
            name="background image size"
          >
            <MenuItem value={"contain"} primaryText="Contain" />
            <MenuItem value={"cover"} primaryText="Cover" />
          </SelectField>
        </Box>
        <Box w={[1]} py={[1]}>
          <SelectField
            floatingLabelText="Position"
            onChange={(event, index, value) =>
              this.onChangeBackgroundImageProperties(
                event,
                index,
                value,
                "position"
              )
            }
            value={this.state.bgProps.position}
            autoWidth={true}
            name="background image position"
          >
            <MenuItem value={"left"} primaryText="Left" />
            <MenuItem value={"center"} primaryText="Center" />
            <MenuItem value={"right"} primaryText="Right" />
          </SelectField>
        </Box>
        <Box w={[1]} py={[1]}>
          <SelectField
            floatingLabelText="Repeat"
            onChange={(event, index, value) =>
              this.onChangeBackgroundImageProperties(
                event,
                index,
                value,
                "repeat"
              )
            }
            value={this.state.bgProps.repeat}
            autoWidth={true}
            name="background image repeat"
          >
            <MenuItem value={"no-repeat"} primaryText="No Repeat" />
            <MenuItem value={"repeat"} primaryText="Repeat" />
          </SelectField>
        </Box>
        <Box w={[1]} py={[1]}>
          <SelectField
            floatingLabelText="Aspect ratio"
            onChange={(event, index, value) =>
              this.onChangeBackgroundImageProperties(
                event,
                index,
                value,
                "ratio"
              )
            }
            value={this.state.bgProps.ratio}
            autoWidth={true}
            name="background Aspect ratio"
          >
            <MenuItem value={1} primaryText="1" />
            <MenuItem value={1.2} primaryText="1.2" />
            <MenuItem value={1.4} primaryText="1.4" />
            <MenuItem value={1.5} primaryText="1.5" />
            <MenuItem value={1.7} primaryText="1.7" />
            <MenuItem value={1.8} primaryText="1.8" />
            <MenuItem value={2} primaryText="2" />
          </SelectField>
        </Box>
        <DivTitle>Background Image</DivTitle>
        <UploadImage
          type={"ease"}
          imageUrl={this.state.backgroundImage}
          onUpdateUrl={value => this.onUpdateUrl(value)}
          title="Image"
        />
      </div>
    );
  }

  render() {
    return (
      <Box w={[1]}>
        {/* <DivTitle>{this.props.title}</DivTitle> */}

        <Paper style={styles.paperText} zDepth={1}>
          <DivTitle>Container Width</DivTitle>
          <Box w={[1]} pb={[1]}>
            <RadioButtonGroup
              name="type"
              valueSelected={this.state.type}
              onChange={this.onChangeType}
              style={styles.radioGroup}
            >
              <RadioButton
                value="%"
                label="Percent"
                style={styles.radioButton}
              />
              <RadioButton
                value="px"
                label="Pixel"
                style={styles.radioButton}
              />
            </RadioButtonGroup>
            <Counter
              isDisabled={false}
              onSetValue={value => this.onSetValue("Width", value)}
              value={this.state.contentWidth}
              interval={this.state.interval}
              maxValue={this.state.maxValueWidth}
            />
          </Box>
        </Paper>
        <Paper style={styles.paperText} zDepth={1}>
          <DivTitle>Padding</DivTitle>
          <BlockCounter
            containerPadding={this.state.padding}
            onUpdatePadding={containerPadding =>
              this.onUpdatePadding(containerPadding)
            }
          />
        </Paper>
        <Paper style={styles.paperText} zDepth={1}>
          <DivTitle>Content Vertical align</DivTitle>
          <Alignment
            value={this.state.valign}
            onChange={value => this.onChangeContentVerticalAlign(value)}
            title=""
          />
        </Paper>
        <Paper style={styles.paperText} zDepth={1}>
          <DivTitle>Content Horizontal align</DivTitle>
          <Alignment
            value={this.state.align}
            onChange={value => this.onChangeContentHorizontalAlign(value)}
            title=""
          />
        </Paper>
        <Paper style={styles.paperText} zDepth={1}>
          <SketchColorPicker
            title={"Container Parent Background Color"}
            onUpdateColor={color => this.onUpdateColorParent(color)}
            color={this.state.backgroundColorParent}
          />
        </Paper>
        <Paper style={styles.paperText} zDepth={1}>
          <SketchColorPicker
            title={"Background Color"}
            onUpdateColor={color => this.onUpdateColor(color)}
            color={this.state.backgroundColor}
          />
        </Paper>
        <Paper style={styles.paperText} zDepth={1}>
          <Box w={[1]} py={[1]}>
            <Toggle
              label="Using background image"
              style={{ marginBottom: 10 }}
              toggled={this.state.isBackgroundImage}
              onToggle={(e, v) => this.onToggle(e, v)}
            />
          </Box>
          {this.state.isBackgroundImage && this.renderBackgroundImage()}
        </Paper>
      </Box>
    );
  }
}

ItemBackgroundCarousel.propTypes = {
  updateBackground: PropTypes.func,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.object,
  bgProps: PropTypes.object,
  isBackgroundImage: PropTypes.bool,
  title: PropTypes.string,
  typeBackground: PropTypes.number,
  backgroundCarousel: PropTypes.object,
  isShowDelete: PropTypes.bool
};

ItemBackgroundCarousel.defaultProps = {
  isShowDelete: true,
  title: "Background Row",
  backgroundImage: { url: "", urlMobile: "" },
  backgroundColor: "#FFFFFF",
  isBackgroundImage: false,
  bgProps: {
    size: "cover",
    position: "center",
    repeat: "no-repeat",
    ratio: 1.2
  },
  padding: "0px",
  width: { type: "%", contentWidth: 100 },
  alignment: {
    vertical: "center",
    horizontal: "center"
  }
};

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  radioButton: {
    width: 100
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto",
    marginBottom: 10
  }
};

export default ItemBackgroundCarousel;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/bgContent/ItemBackgroundCarousel.js